import { Fragment, useState } from 'react'
import { Transition } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'

export default function VideoEmbed({ videoLink }) {
  const [ showVideo, setShowVideo ] = useState(true)
  const [ showReminder, setShowReminder ] = useState(false)
  //console.log('videolink', videoLink)

  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-x-0 flex items-end px-4 py-6 sm:items-start sm:p-6 bottom-4 right-4"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={showReminder}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setShowVideo(true)}
          >
            <div className="pointer-events-auto">
              <span
                onClick={() => setShowReminder(false)}
                className="inline-flex items-center rounded-full bg-pinto px-2.5 py-0.5 text-xs font-medium text-white cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="-ml-0.5 mr-1.5 w-2 h-2 text-white">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 19.5l-15-15m0 0v11.25m0-11.25h11.25" />
                </svg>

                View Report Review
              </span>
            </div>
          </Transition>
          <Transition
            show={showVideo}
            afterLeave={() => setShowReminder(true)}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">Your Report Review</p>
                    {/*<img
                      className="my-4"
                      src="https://i.imgur.com/n255fhN.png"
                      width="320"
                      height="240"
                    />*/}
                    <iframe
                      src={`${videoLink}?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`}
                      allowFullScreen
                      frameBorder="0"
                      style={{width: '320px', height: '240px'}}
                      className="my-2"
                    >
                    </iframe>
                    {/*<p className="mt-1 text-sm text-gray-500">Anyone with a link can now view this file.</p>*/}
                    {/*<iframe
                      src="https://player.vimeo.com/video/56282283?h=ac171d413b"
                      className="my-2"
                      width="320"
                      height="240"
                      frameborder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowfullscreen>
                    </iframe>*/}
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                  {/*<div className="absolute -right-2">*/}
                    <button
                      type="button"
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => {
                        setShowVideo(false)
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  )
}
